import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import ReceiptsPage from "../modules/Receipts/ReceiptsPage";

export function Receipts() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "receipts-page-title",
    defaultMessage: "Receipts"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <ReceiptsPage/>;
}
